import { Paths } from '../../types'

export function pathsFixture({
  dashboardPath = '/subscriptions',
  dashboardUrl = 'https://www.hpinstantink.com/subscriptions',
  signOutPath = '/users/logout',
  termsPath = '/us/en/terms',
  subscriptionCancellationSMBPath = '//hpinstantink.com/cancel',
  subscriptionCancellationConsumerPath = '//pie1.hpinstantink.com/cancel',
  smbPortalPath = '//smb.portal.com/instantink/overview',
  subscriptionCancellationFormUrl = '//instantink-pie1.hpconnectedpie.com/de/de/l/v2/cancel_subscription'
} = {}): Paths {
  return {
    dashboardPath,
    dashboardUrl,
    signOutPath,
    termsPath,
    subscriptionCancellationSMBPath,
    subscriptionCancellationConsumerPath,
    smbPortalPath,
    subscriptionCancellationFormUrl
  }
}
